<template>
  <div class="wrapper results">
    <h1>Results - 2020</h1>

    <h2>Team Results</h2>
    
    <table class="results-table">
        <tr>
            <th>Place</th>
            <th>Team</th>
            <th>Time (Average)</th>
        </tr>
        <tr v-for="(team, index) in sortResults(teams)" :key="index">
            <td>{{ index + 1 }}</td>
            <td>{{ team['.key'] }}</td>
            <td>{{ formatResultTime(team.time) }}</td>
        </tr>
    </table>

    <h2>Individual Results</h2>
    <table class="results-table">
        <tr>
            <th>Place</th>
            <th>Name</th>
            <th>Time</th>
        </tr>
        <tr v-for="(result, index) in sortResults(results)" :key="index">
            <td>{{ index + 1 }}</td>
            <td>{{ result.name }}</td>
            <td>{{ formatResultTime(result.time) }}</td>
        </tr>
    </table>
  </div>
</template>

<script>
import { db } from '../../environment.ts';

export default {
  name: 'Results',
  mounted() {
      this.calculateTeamTimes();
  },
  firestore() {
    return {
      results: db.collection('results'),
      teams: db.collection('teams')
    }
  },
  methods: {
      sortTeamResults(teams) {
        return teams.sort((a, b) => {
          if (a.time === b.time) return 0;
          return (a.time < b.time) ? -1 : 1;
        })
      },
      calculateTeamTimes() {
        this.$firestore.teams.get().then((teamDoc) => {
            teamDoc.forEach((team) => {
              const teamRef = this.$firestore.teams.doc(team.id);
              teamRef.get().then((teamDoc) => {
                const memberTimes = teamDoc.data().memberTimes;
                const average = Object.keys(memberTimes).reduce((acc, bib) => {
                  if (memberTimes[bib] === null) return acc;
                  if (acc === null) return memberTimes[bib];
                  return (memberTimes[bib] + acc) / 2
                }, null)
                teamRef.update({time: average})
              })
            })
        })
      },
      sortResults: function(results) {
          return results
          .filter((result) => result.time !== undefined && result.time !== null)
          .sort((a, b) => {
              if (a.time === b.time) return 0;
              return (a.time < b.time) ? -1 : 1;
          })
      },
      formatResultTime(seconds) {
          if (!seconds) return seconds
          return new Date(Number(seconds) * 1000).toISOString().substr(11, 8)
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.wrapper.results {
  padding: 40px;
}
.results-table {
    border-collapse: collapse;
    font-family: sans-serif;
    text-align: left;
}
.results-table tr {
  border: solid 1px;
}
.results-table td,
.results-table th {
  padding: 5px 15px;
}
</style>
